module.exports = __webpack_public_path__ + "img/mlh_honor_4.6bdcdf91.png";